export default __webpack_public_path__ + "static/Metal_Triangle_Foundation-f426ef31552ae0209367c211c52cb99d.png";